import { render, staticRenderFns } from "./ReportTabMeals.vue?vue&type=template&id=de0bbcd6"
import script from "./ReportTabMeals.vue?vue&type=script&lang=js"
export * from "./ReportTabMeals.vue?vue&type=script&lang=js"
import style0 from "./ReportTabMeals.vue?vue&type=style&index=0&id=de0bbcd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports